import React from 'react';
import { PRIVACY_EMAIL, EFFECTIVE_DATE } from '../constants';
import './LegalModal.css';

const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2>Privacy Policy</h2>
        <p className="effective-date">Effective Date: {EFFECTIVE_DATE}</p>
        
        <div className="legal-content">
          <section>
            <h3>1. Who We Are</h3>
            <p>
              This Privacy Policy explains how School 21 LLC dba DoZESQ Imaginarium ("we") handles 
              information collected through Where's Junior, a project created in collaboration with 
              the Jeffrey Lucas Gurmendi Marshall Foundation.
            </p>
          </section>

          <section>
            <h3>2. Information We Collect</h3>
            <ul>
              <li>Basic account info (name and email if you create a profile)</li>
              <li>Content you share (photos, videos, messages)</li>
              <li>Technical data (minimal log data like browser type and IP address for security)</li>
              <li>Cookies (only essential cookies for sign-in and session security; no analytics or ads)</li>
            </ul>
          </section>

          <section>
            <h3>3. How We Use the Information</h3>
            <ul>
              <li>To operate and maintain the App</li>
              <li>To display shared memories and moderate content</li>
              <li>To respond to support requests</li>
            </ul>
            <p>
              We do not sell, rent, or share your personal information with anyone outside our 
              small operations team.
            </p>
          </section>

          <section>
            <h3>4. Legal Basis (EU/UK Visitors)</h3>
            <p>
              Our lawful basis is legitimate interest in providing the App and your consent when 
              you choose to submit content.
            </p>
          </section>

          <section>
            <h3>5. Data Storage and Retention</h3>
            <p>
              Data is stored securely in the United States on AWS servers. We retain your content 
              while your account is active or until you delete it.
            </p>
          </section>

          <section>
            <h3>6. Your Choices</h3>
            <p>
              You can request deletion of your posts or account by emailing{' '}
              <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            </p>
          </section>
        </div>
        
        <button className="close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default PrivacyModal;